import React, { useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "../layouts";
import { routes } from "./routesConfig";
import { clearSelectedProduct } from "../redux/slices/productDetailSlice";

const RouteWatcher: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const isOnProductPage = location.pathname.startsWith("/product/");
    if (!isOnProductPage) {
      dispatch(clearSelectedProduct());
    }
  }, [location.pathname, dispatch]);

  return null; // this component renders nothing
};

const AppRouter: React.FC = () => {
  return (
    <Router>
      <RouteWatcher />
      <Routes>
        {routes.map(({ path, component: Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Layout>
                <Component />
              </Layout>
            }
          />
        ))}
      </Routes>
    </Router>
  );
};

export default AppRouter;